import { useIsMobile } from "@/hooks/useIsMobile";
import classes from "@/styles/fulfilment-partners/purolator.module.css";
import { purolatorShipNowImages } from "@/utils/images";
import { routes } from "@/utils/routes";
import Image from "next/image";
import Link from "next/link";

import React, { CSSProperties } from "react";
import {
  Card,
  CardBody,
  CardImg,
  CardImgOverlay,
  CardText,
  CardTitle,
  Col,
  Container,
  Row,
} from "reactstrap";

function PurolatorShipNow() {
  const isMobile = useIsMobile();

  const imgStyle: CSSProperties = {
    width: "154px",
    height: "154px",
    boxSizing: "border-box",
    borderRadius: "0px",
    maxHeight: "100%",
    maxWidth: "100%",
  };

  const stepsMargin: CSSProperties = {
    marginBottom: "20px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    padding: "10px",
  };

  const buttonStyle: CSSProperties = {
    color: "#011766",
    background: "none",
    border: "2px solid #011766",
    textAlign: "center",
    padding: "8px 16px",
    // display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  };

  const imageHeadingStyle: CSSProperties = {
    boxShadow: "inset 0px -18px 0px 0px #e6e6e6",
    color: "#011766",
    fontSize: isMobile ? "30px" : "48px",
  };

  const imageParghStyle: CSSProperties = {
    backgroundColor: "#e6e6e6",
    color: "#011766",
  };

  return (
    <main className={classes.container}>
      <section>
        <Container>
          <Card>
            <CardImg
              alt="Card image cap"
              src={`${purolatorShipNowImages["how-to-do-packaging"]}`}
              style={{
                height: 450,
                objectFit: "cover",
                position: "relative",
                filter: "blur(5px)",
              }}
              width="100%"
            />
            <CardImgOverlay style={{ textAlign: "right" }}>
              {/* divider */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                <div
                  style={{
                    height: "5px",
                    backgroundColor: "#011766",
                    width: "34%",
                  }}
                ></div>
              </div>
              {/* Heading */}
              <h1 style={{ padding: "20px 20px" }}>
                <span style={imageHeadingStyle}>
                  How to Packa​​​​​​​ge Your Shipment
                </span>
              </h1>
              {/* Paragraph */}
              <p style={{ padding: "10px 10px" }}>
                <span style={imageParghStyle}>
                  Ensure your package is safe and secure by following these
                  steps. Proper packaging helps prevent damage during transit
                </span>
              </p>
              {/* divider */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    height: "5px",
                    backgroundColor: "#011766",
                    width: "34%",
                  }}
                ></div>
              </div>
            </CardImgOverlay>
          </Card>
        </Container>
      </section>
      <section className="my-3 container">
        <div
          style={{ textAlign: "right", color: "#011766", fontWeight: "bold" }}
        >
          <div style={{ padding: "20px 0px" }}>
            <h3>Choose from a variety of</h3>
            <h3>shipping solutions to meet</h3>
            <h3>your shipping needs.</h3>
          </div>

          <Link href={`${routes.register}`}>
            <button style={buttonStyle}>
              <h5 style={{ margin: 0 }}> LOG IN</h5>
            </button>
          </Link>
        </div>
      </section>
      <section className="my-3 container">
        <Container style={{ alignItems: "center", textAlign: "center" }}>
          {/* 1 */}
          <Row md="4" style={stepsMargin}>
            <Col>
              <Image
                src={purolatorShipNowImages.chooseTheRightBox}
                alt="chooseTheRightBox"
                style={imgStyle}
                width={500}
                height={500}
              />
            </Col>
            <Col md="9">
              <h5>Step 1: Choose the Right Box</h5>
              <p>
                Make sure the box is sturdy and appropriate for the size and
                weight of your item. Reuse boxes only if they are in good
                condition and have no signs of wear and tear.
              </p>
            </Col>
          </Row>
          {/* 2 */}
          <Row md="4" style={stepsMargin}>
            <Col>
              <Image
                src={purolatorShipNowImages.ProtectYourItems}
                alt="ProtectYourItems"
                style={imgStyle}
                width={300}
                height={300}
              />
            </Col>
            <Col md="9">
              <h5>Step 2: Protect Your Items</h5>
              <p>
                Use bubble wrap, foam peanuts, or other cushioning materials to
                protect fragile items. Fill all empty spaces in the box to
                prevent movement.
              </p>
            </Col>
          </Row>
          {/* 3 */}
          <Row md="4" style={stepsMargin}>
            <Col>
              <Image
                src={purolatorShipNowImages.SealThePackageSecurely}
                alt="SealThePackageSecurely"
                style={imgStyle}
                width={300}
                height={300}
              />
            </Col>
            <Col md="9">
              <h5>Step 3: Seal the Package Securely</h5>
              <p>
                Use strong tape to seal all seams of the box. Reinforce the
                edges for extra security. Avoid using string or paper over-wrap,
                as they can get caught in automated sorting equipment.
              </p>
            </Col>
          </Row>
          {/* 4 */}
          <Row md="4" style={stepsMargin}>
            <Col>
              <Image
                src={purolatorShipNowImages.LabelYourPackageCorrectly}
                alt="LabelYourPackageCorrectly"
                style={imgStyle}
                width={300}
                height={300}
              />
            </Col>
            <Col md="9">
              <h5>Step 4: Label Your Package Clearly</h5>
              <p>
                Write the destination and return addresses clearly on the
                package. Use a label or directly write on the box with a
                permanent marker.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="my-3 container">
        <Container style={{ textAlign: "center", alignItems: "center" }}>
          {/* Heading */}
          <h2 style={{ paddingBottom: "20px" }}>
            Packaging Guidelines by Item Type
          </h2>
          {/* Non-Fragile Items */}
          <Card className="my-2">
            <CardBody>
              <CardTitle tag="h5">Non-Fragile Items</CardTitle>
              <CardText>
                For non-fragile items such as books, clothes, and electronics,
                ensure that the items are securely packed in a box that fits
                their size. Use a box that can hold the weight of the items
                without bending or breaking. Filling any voids with packing
                material to prevent movement is essential.
              </CardText>
            </CardBody>
          </Card>
          {/* Fragile Items */}
          <Card className="my-2">
            <CardBody>
              <CardTitle tag="h5">Fragile Items</CardTitle>
              <CardText>
                Fragile items, like glassware, ceramics, or electronics, require
                extra care. Wrap each item individually with bubble wrap or
                foam. Place the wrapped item in the center of the box and
                surround it with cushioning materials like foam peanuts or air
                cushions. Ensure that the item does not touch the box&apos;s
                walls, reducing the risk of breakage during transit.
              </CardText>
              <CardText>
                Consider double boxing for added protection: place the first box
                containing the wrapped item inside a second, larger box filled
                with more cushioning materials.
              </CardText>
            </CardBody>
          </Card>
          {/* Pallets (Freight) */}
          <Card className="my-2">
            <CardBody>
              <CardTitle tag="h5">Pallets (Freight)</CardTitle>
              <CardText>
                For shipping large items or bulk shipments, palletizing your
                cargo is essential. Secure the items on a pallet using straps,
                shrink wrap, or both. Ensure the weight is evenly distributed,
                and the items are not overhanging the pallet&apos;s edges.
              </CardText>
              <CardText>
                Use corner protectors to prevent damage to the edges of the
                items. Label the pallet clearly with the destination address,
                and if applicable, mark the pallet as &quot;Heavy&quot; to alert
                handlers.
              </CardText>
            </CardBody>
          </Card>
        </Container>
      </section>
      <section className="my-3 container">
        <Container style={{ textAlign: "center", alignItems: "center" }}>
          {/* Heading */}
          <h2 style={{ padding: "20px 0px" }}>
            Additional Tips for Packing Valuables
          </h2>
          <Card>
            <CardBody>
              <p>
                When packing valuables, always take extra precautions to ensure
                their safety. Here are some additional tips to keep in mind:
              </p>
              <p>
                <b>Plan Ahead:</b> Start packing early to avoid last-minute
                stress. This gives you time to gather all necessary materials
                and pack items carefully.
              </p>
              <p>
                <b>Inventory and Document:</b> Keep a detailed inventory of all
                valuable items. Take photographs before packing, which can be
                useful if you need to file an insurance claim.
              </p>
              <p>
                <b>Disassemble When Possible:</b> If the item can be safely
                disassembled, do so. Wrap each part separately and label them
                for easy reassembly.
              </p>
              <p>
                <b>Seal and Reinforce:</b> Ensure that all boxes are securely
                sealed with strong tape. Reinforce the bottom of the boxes to
                prevent them from collapsing under the weight of the contents.
              </p>
              <p>
                Following these steps will help ensure that your valuables are
                well-protected and arrive at their destination in the same
                condition as when they were packed.
              </p>
            </CardBody>
          </Card>
        </Container>
      </section>
    </main>
  );
}

export default PurolatorShipNow;
